import { curry } from 'ramda';
import toAction from './toAction';

const dispatchFetchError = curry(
  (dispatch, action, err) =>
    dispatch(toAction(action, err))
);

export default dispatchFetchError;
